import {schoolChangeActionTypes as types} from '../constants';

export function initializeUserSchoolChange(payload) {
  return {
    type: types.INITIALIZE_CHANGE_SCHOOL_REQUEST,
    payload
  };
}

export function getSchoolChangeSuccess() {
  return {type: types.SCHOOL_CHANGE_LOAD_SUCCESS};
}

export function getSchoolChangeFailure(error) {
  return {type: types.SCHOOL_CHANGE_LOAD_FAILURE, error};
}
